import script from "./DialogYlz.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogYlz.vue?vue&type=script&setup=true&lang=ts"

import "./DialogYlz.vue?vue&type=style&index=0&id=57ac4a8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ac4a8c"]])

export default __exports__